import { isEU } from "@/lib/constants";

export function EuBadge({ country }) {
  if (!country) return null;
  const eu = isEU(country);
  return (
    <span
      data-testid={`eu-badge-${eu ? "eu" : "extra"}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${
        eu ? "text-sky-300 border-sky-500/40 bg-sky-500/[0.06]" : "text-amber-300 border-amber-500/40 bg-amber-500/[0.06]"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${eu ? "bg-sky-400" : "bg-amber-400"}`} />
      {eu ? "UE" : "Extra-UE — dogana"}
    </span>
  );
}
